import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import LoaderSkeleton from '~/shared/components/LoaderSkeleton'
import StatsProgressBar from '~/statistics-v2/components/StatsProgressBar'
import { MustKnowsProgressCardProps } from '~/statistics-v2/types/statistics.types'
import { calculateProgress } from '~/statistics-v2/utils/statistics.utils'

export default function MustKnowsProgressCard({
  mustKnowProgressCardProps,
  isLoading = false,
}: {
  mustKnowProgressCardProps: MustKnowsProgressCardProps
  isLoading?: boolean
}): React.ReactElement {
  const { t } = useTranslation('statisticsV2')
  const { total, completed } = mustKnowProgressCardProps
  const progressPercentage = calculateProgress(completed, total)

  return (
    <div className="flex justify-center items-center h-46 w-full lg:w-125 border rounded-6 border-purple/50 bg-purple-gdark overflow-hidden">
      {isLoading ? (
        <LoaderSkeleton className="absolute min-h-full min-w-full rounded-6 bg-transparent" randomStart speed={1200} />
      ) : (
        <div className="flex flex-col justify-between px-4 py-3 gap-4 w-full h-full">
          <div className="flex flex-grow lg:h-full lg:justify-evenly">
            <div className="flex flex-col lg:gap-1 w-full ">
              <p className="text-white text-sm font-bold leading-8">{t('mustKnows')}</p>
              <div className="flex pt-8">
                <p className="text-white text-3xl font-bold leading-8">{completed}</p>
                <p className="text-3xl font-medium text-blue-pastel leading-8">/{total}</p>
              </div>
            </div>

            <div className="flex justify-center items-center lg:w-full">
              <ResponsiveImage
                alt="Puzzle Icon"
                className="w-10 mr-4"
                height={200}
                srcKey="onboarding/icons/no-space-puzzle-piece.svg"
                width={133}
              />
            </div>
          </div>
          <StatsProgressBar
            barType="straight"
            FirstSubtitle={`${progressPercentage}% ${t('mastered')}`}
            progressPercentage={progressPercentage}
          />
        </div>
      )}
    </div>
  )
}
